/**
 * chartFunding.service — historical funding rate (% per 8h) for Delta
 * perpetuals, backing the Charts "Funding" indicator.
 *
 * Backed by GET /v1/charts/funding (stored 1h series, lazily backfilled from
 * Delta's FUNDING:{symbol} history). Times are seconds-since-epoch (UTC).
 */
import api from './api';

export interface FundingPoint {
  /** Seconds since epoch (UTC). */
  time: number;
  /** Funding rate, percent per 8 hours. */
  rate: number;
}

export const chartFundingService = {
  /** Fetch funding-rate points for a symbol over [fromSec, toSec] (UTC seconds). */
  async getHistory(symbol: string, fromSec: number, toSec: number): Promise<FundingPoint[]> {
    if (!symbol) return [];
    try {
      const r = await api.get<{ success: boolean; data: { funding: FundingPoint[] } }>('/charts/funding', {
        params: { symbol, start: Math.floor(fromSec), end: Math.floor(toSec) },
        headers: { _suppressToast: 'true' },
      });
      return r.data?.data?.funding || [];
    } catch {
      return [];
    }
  },
};
